import dayjs from "dayjs";
import { useIntl } from "react-intl";

import { FlightRouteLabel } from "@/features/flights/components/flight-purchase/FlightRouteLabel";
import type { GetFlightAvailabilityTokenFlightV2 } from "@/types/codegen";

type Props = {
  flightDetails: GetFlightAvailabilityTokenFlightV2;
  segmentDirection?: "departure" | "return";
};

export const FlightRouteAndDate = ({
  flightDetails,
  segmentDirection,
}: Props) => {
  const intl = useIntl();

  const firstSegment = flightDetails.segments[0];
  const lastSegment = flightDetails.segments[flightDetails.segments.length - 1];
  const departureCity = firstSegment.departure.city.name;
  const arrivalCity = lastSegment.arrival.city.name;
  const departureDate = dayjs(
    `${firstSegment.departure.date}T${firstSegment.departure.time}`,
  );
  const arrivalDate = dayjs(
    `${lastSegment.arrival.date}T${lastSegment.arrival.time}`,
  );

  return (
    <div className="space-y-0.5">
      <FlightRouteLabel
        routeLabels={[departureCity, arrivalCity]}
        segmentDirection={segmentDirection}
        variant="small"
      />
      <div className="ms-7 text-xs font-normal text-text-primary">
        {arrivalDate.isSame(departureDate, "day")
          ? intl.formatMessage(
              {
                defaultMessage:
                  "{departureDate, date, ::EEEMMMd} <divider>|</divider> {departureDate, time, short} - {arrivalDate, time, short}",
                description:
                  "Formatted date and time range for a flight segment when departure and arrival are on the same day",
              },
              {
                departureDate: departureDate.toDate(),
                arrivalDate: arrivalDate.toDate(),
                divider: (chunks) => (
                  <span className="text-stroke-neutral-soft">{chunks}</span>
                ),
              },
            )
          : intl.formatMessage(
              {
                defaultMessage:
                  "{departureDate, date, ::EEEMMMd}, {departureDate, time, short} - {arrivalDate, date, ::EEEMMMd}, {arrivalDate, time, short}",
                description:
                  "Formatted date and time range for a flight segment when departure and arrival are on different days",
              },
              {
                departureDate: departureDate.toDate(),
                arrivalDate: arrivalDate.toDate(),
              },
            )}
      </div>
    </div>
  );
};
